export default "__VITE_ASSET__CXn8D7Yk__"